import React, { useEffect, Fragment, useState, useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import { Unity, useUnityContext } from "react-unity-webgl";
import { Prompt, useLocation } from "react-router-dom";
import classNames from "classnames";

const Game = () => {

    const {
        library,
        chainId,
        account,
        activate,
        deactivate,
        active
    } = useWeb3React();

    const [score, setScore] = useState(0);

    const { unityProvider, isLoaded, loadingProgression, unload, addEventListener, removeEventListener, sendMessage } = useUnityContext({
        loaderUrl: "https://eduversenft.s3.amazonaws.com/game/Build.loader.js",
        dataUrl: "https://eduversenft.s3.amazonaws.com/game/Build.data",
        frameworkUrl: "https://eduversenft.s3.amazonaws.com/game/Build.framework.js",
        codeUrl: "https://eduversenft.s3.amazonaws.com/game/Build.wasm",
    });

    const handleGetScore = useCallback((score) => {
        setScore(score);
    }, []);

    useEffect(() => {
        addEventListener("GetScore", handleGetScore);
        return () => {
            removeEventListener("GetScore", handleGetScore);
        }
    }, [addEventListener, removeEventListener, handleGetScore]);

    /*
    useEffect(() => {
        if(unityProvider != null && isLoaded){
            sendMessage("WalletID", "GetWalletID", account);
        } 
    });
    */

    const hardCodedLeaderBoard = [
        {
            wallet: "0x29d7d1dd5b6f9c864d9db560d72a247c178ae86b",
            score: 9843,
        },
        {
            wallet: "c257274276a4e539741ca11b590b9447b26a8051",
            score: 9421,
        },
        {
            wallet: "0xc0ffee254729296a45a3885639AC7E10F9d54979",
            score: 8534,
        },
    ];

    return (
        <section className={classNames("section", "center-content", "game-section")}>
            <div className="container-sm">
                <div className="game-container">
                    <h1>Game</h1>
                    {active ? (
                        <>
                            {isLoaded === false && (
                                <div className="loading-overlay">
                                <p>Loading... ({Math.round(loadingProgression * 100)}%)</p>
                                </div>
                            )}
                            <Unity className="unity" unityProvider={unityProvider} style={{ width: 960, height: 600 }}/>
                             <p>{`You've scored ${score} points, earning you 100 tokens.`}</p>
                            <div className="game-leaderboard">
                                <h2 className="game-leaderboard-heading">Top 10 Leaderboard</h2>
                                <table>
                                    <tr>
                                        <th>Wallet</th>
                                        <th>Score</th>   
                                    </tr>

                                    {
                                        hardCodedLeaderBoard.map((data) => {
                                            return (
                                                <tr>
                                                    <td>{data?.wallet}</td>
                                                    <td>{data?.score}</td>
                                                </tr>
                                            );
                                        })
                                    }
                                </table>
                            </div>
                        </>
                    ): (
                        <p>You must be connected to play the game</p>
                    )}
                </div>
            </div>
        </section>
    )
}

export default Game;